var map = {
	"./IconCustomers.png": "9ea8",
	"./IconFlightDeck.png": "40cf",
	"./IconFlightDeckLight.png": "6410",
	"./IconInventory.png": "46b1",
	"./IconLogbooks.png": "a71f",
	"./IconOrders.png": "393d",
	"./IconPOS.png": "1ee3",
	"./IconPromotions.png": "2642",
	"./IconRange.png": "7068",
	"./IconReports.png": "26db",
	"./IconWebsite.png": "c2d2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c45";